import React, { useState, useEffect } from 'react'
import './Header.css'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt'
import axios from 'axios'

import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { getData } from '../api/indexedDBHandler'
import { clearTable } from '../api/indexedDBHandler'
import { useDispatch, useSelector } from 'react-redux'
import { loginSuccess, nameSuccess, logout } from '../slices/authSlice'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import MailIcon from '@mui/icons-material/Mail'
import {
  Avatar,
  Typography,
  Card,
  CardContent,
  Paper,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const Header = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [open, setOpen] = React.useState(false)
  const [user, setUser] = useState(null)
  const [sessions, setSessions] = useState([])
  const [sessionsOpen, setSessionsOpen] = useState(false)

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleSessions = () => {
    setSessionsOpen(!sessionsOpen)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const getuser = async () => {
      try {
        const results = await getData('user', 'created', true)
        const value = results[0]?.value || null
        setUser(value)
      } catch (error) {
        console.error('Error fetching user:', error)
        setUser(null)
      }
    }

    getuser()
  }, [])

  const buttonClear = async () => {
    await clearTable('requests')
  }

  const buttonClearBD = async () => {
    await clearTable('requests')
    await clearTable('protocols')
    await clearTable('tournaments')
    await clearTable('archive')
    await clearTable('teams')
    await clearTable('communication')
    await clearTable('stage')
    await clearTable('sponsors')
    await clearTable('user')
    dispatch(logout())
  }

  const buttonExit = async () => {
    await clearTable('user')
    dispatch(logout())
  }

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const sessionToken = localStorage.getItem('sessionToken')

        if (sessionToken) {
          const sessionsData = await getUserSessions(sessionToken)
          setSessions(sessionsData)
        }
      } catch (error) {
        console.error('Error fetching sessions:', error)
        setSessions([])
      }
    }

    fetchSessions()
  }, [])

  const getUserSessions = async (token) => {
    try {
      const response = await axios.post(
        `https://www.admin-protocarp.ru/php/user-sessions.php`,
        {
          token,
          action: 'get',
        }
      )
      return response.data
    } catch (error) {
      console.error('Failed to fetch sessions:', error.response?.data)
      return []
    }
  }

  const terminateSession = async (sessionIdToTerminate) => {
    try {
      const response = await axios.post(
        `https://www.admin-protocarp.ru/php/user-sessions.php`,
        {
          token: JSON.parse(localStorage.getItem('sessionToken')),
          action: 'terminate',
          sessionId: sessionIdToTerminate,
        }
      )

      if (response.data.success) {
        setSessions(
          sessions.filter((session) => session.id !== sessionIdToTerminate)
        )
      }

      return response.data.success
    } catch (error) {
      console.error('Failed to terminate session:', error.response?.data)
      return false
    }
  }

  function DeviceSession({ session }) {
    const lastActive = new Date(session.last_activity).toLocaleString()
    const location = `${session.city}, ${session.region}, ${session.country}`
    const isCurrent =
      session.session_token === localStorage.getItem('sessionToken')

    return (
      <Paper elevation={2} sx={{ mb: 2, p: 2, position: 'relative' }}>
        {isCurrent && (
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'primary.main',
              color: 'white',
              px: 1,
              borderRadius: 1,
              fontSize: '0.75rem',
            }}
          >
            Текущая сессия
          </Box>
        )}

        <Box display="flex" alignItems="center" mb={1}>
          <Box sx={{ mr: 2, fontSize: '1.5rem' }}>
            {session.device_type === 'mobile'
              ? '📱'
              : session.device_type === 'tablet'
                ? '📲'
                : '💻'}
          </Box>
          <Box>
            <Typography variant="subtitle1">
              {session.browser} {session.os} {session.os_version}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="body2">
            <strong>Местоположение:</strong> {location} (ISP: {session.isp})
          </Typography>
          <Typography variant="body2">
            <strong>IP:</strong> {session.ip_address}
          </Typography>
          <Typography variant="body2">
            <strong>Вход в систему:</strong> {lastActive}
          </Typography>
        </Box>

        {!isCurrent && (
          <Box mt={1} display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={() => terminateSession(session.id)}
            >
              Завершить сеанс
            </Button>
          </Box>
        )}
      </Paper>
    )
  }

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" color="inherit">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src="/images/logogor.png"
              style={{ maxHeight: '40px' }}
              alt="logo"
            />
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              size="large"
              edge="end"
              sx={{ color: isOnline ? 'green' : 'red' }}
              aria-label="network"
            >
              <SignalCellularAltIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Box>

      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        anchor="left"
        sx={{
          '& .MuiDrawer-paper': {
            width: '90%',
            maxWidth: 400,
            boxSizing: 'border-box',
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {user && (
          <Box
            sx={{
              width: '90%',
              p: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto',
            }}
          >
            <Card sx={{ mb: 2, flexShrink: 0 }}>
              <CardContent>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={2}
                >
                  <Avatar
                    alt={user.name}
                    src={user.photo}
                    sx={{ width: 100, height: 100 }}
                  />
                  <Typography variant="h6" component="div" align="center">
                    {user.surname} {user.name} {user.patronymic}
                  </Typography>

                  <Paper
                    elevation={0}
                    sx={{
                      width: '90%',
                      backgroundColor: '#f5f5f5',
                      padding: 2,
                      borderRadius: 2,
                    }}
                  >
                    <Typography variant="body2" color="textSecondary">
                      <strong>ID:</strong> {user.id}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      <strong>Код:</strong> {user.code}
                    </Typography>
                  </Paper>
                </Box>
                <Typography
                  className="color-text-gray"
                  variant="caption"
                  gutterBottom
                  sx={{ display: 'block', mt: 1 }}
                >
                  Версия программы: 0.3.37
                </Typography>
              </CardContent>
            </Card>

            <List>
              <ListItem button onClick={toggleSessions}>
                <ListItemText primary="Активные сеансы" />
                {sessionsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={sessionsOpen} timeout="auto" unmountOnExit>
                <Box sx={{ pl: 2, pr: 2 }}>
                  {sessions.length > 0 ? (
                    sessions.map((session) => (
                      <DeviceSession key={session.id} session={session} />
                    ))
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ p: 2 }}
                    >
                      Нет активных сеансов
                    </Typography>
                  )}
                </Box>
              </Collapse>
            </List>

            <Box sx={{ pt: 1 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={buttonClear}
                fullWidth
              >
                Стереть очередь на отправку
              </Button>
            </Box>

            <Box sx={{ pt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={buttonClearBD}
                fullWidth
              >
                Стереть кеш баз данных
              </Button>
            </Box>
            <Box sx={{ mt: 'auto', pt: 2 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={buttonExit}
                fullWidth
              >
                Выйти из ПротоКарпа
              </Button>
            </Box>
          </Box>
        )}
      </Drawer>
    </>
  )
}

export default Header
